import type { HelpFile } from '../../types/help'
import { UnifiedSearchBarTestIds } from '../../../testids/UnifiedSearchBarTestIds'

export const unifiedSearchBarHelp: HelpFile = {
  docPage: '/docs/reference/unified-search',
  texts: {
    [UnifiedSearchBarTestIds.unifiedSearchBar]: null,
    [UnifiedSearchBarTestIds.inputSearch]:
      "Free-text search across the page's primary text columns — press Enter or the magnifying-glass icon to submit.",
    [UnifiedSearchBarTestIds.btnFilterTrigger]:
      'Open structured filters — radios for single-choice, checkboxes for multi-choice, date pickers for dates.',
    [UnifiedSearchBarTestIds.btnClearSearch]: null,
  },
}
